export default "__VITE_ASSET__J5d0EBWb__"